import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../config';
import i18n from '../i18n';
import { loadAppSettings } from '../utils/appSettings';

const tr = i18n.t.bind(i18n);

const GROUPS = [
  {
    title: 'Reservations & no-show',
    fields: [
      ['reservation_duration', 'Reservation duration (minutes)', 'How long a table stays occupied per reservation'],
      ['noshow_after_min', 'Auto no-show after (minutes)', 'A non-seated reservation is auto-cancelled this long after arrival time'],
      ['noshow_grace_min', 'Grace period (minutes)', 'After an edit or an undo, the no-show timer waits this long'],
    ],
  },
  {
    title: 'Screen refresh',
    fields: [
      ['poll_fast_sec', 'Fast screens (seconds)', 'Kitchen & Service refresh rate'],
      ['poll_normal_sec', 'Standard screens (seconds)', 'BBQ, station screens and orders refresh rate'],
    ],
  },
  {
    title: 'Data retention',
    fields: [
      ['retention_months', 'Client history retention (months)', 'Older reservations/cancellations are purged nightly. Bounded so recent data is never lost and the database never overfills.'],
    ],
  },
];

const SystemSettings = () => {
  const [settings, setSettings] = useState(null);
  const [bounds, setBounds] = useState({});
  const [drafts, setDrafts] = useState({});
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const { data } = await axios.get(`${config.API_BASE_URL}/company-settings`);
      setSettings(data.settings); setBounds(data.bounds || {}); setDrafts({});
    } catch { /* hidden for non-admins on save anyway */ }
  };
  useEffect(() => { load(); }, []);

  if (!settings) return null;

  const val = (k) => (drafts[k] !== undefined ? drafts[k] : settings[k]);
  const dirty = Object.keys(drafts).length > 0;

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await axios.put(`${config.API_BASE_URL}/company-settings`, drafts);
      setSettings(data.settings); setDrafts({});
      loadAppSettings(); // refresh the local cache used by the pollers
      toast.success(tr('Settings saved.'), { autoClose: 2500 });
    } catch (e) {
      toast.error(e?.response?.data?.error || tr('Save failed.'));
    } finally { setSaving(false); }
  };

  return (
    <div style={{ marginTop: 26 }}>
      <h3>{tr('System settings')}</h3>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        {GROUPS.map((g) => (
          <div key={g.title} style={{
            border: '1px solid #ddd', borderRadius: 10, padding: '10px 14px',
            flex: '1 1 280px', minWidth: 260, maxWidth: 420,
          }}>
            <b style={{ display: 'block', marginBottom: 8 }}>{tr(g.title)}</b>
            {g.fields.map(([key, label, hint]) => (
              <div key={key} style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <label style={{ flex: 1, fontSize: 14 }}>{tr(label)}</label>
                  <input type="number" value={val(key)}
                    min={bounds[key]?.min} max={bounds[key]?.max}
                    onChange={(e) => setDrafts((p) => ({ ...p, [key]: e.target.value }))}
                    style={{ width: 76, padding: 6, borderRadius: 6, border: '1px solid #ccc', textAlign: 'right' }} />
                </div>
                <div style={{ fontSize: 11, opacity: 0.6 }}>
                  {tr(hint)} · {bounds[key] ? `${bounds[key].min}–${bounds[key].max}` : ''}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      {dirty && (
        <button className="rlToolbarBtn rlToolbarBtnPrimary" disabled={saving}
          style={{ marginTop: 10, padding: '10px 22px' }} onClick={save}>
          {saving ? tr('Sending...') : tr('Save settings')}
        </button>
      )}
      <p style={{ fontSize: 12, opacity: 0.6, marginTop: 8 }}>
        {tr('Screen refresh changes apply after the staff screens reload.')}
      </p>
    </div>
  );
};

export default SystemSettings;
